export const getDeliveryWorkTypeSettingsEndpoint = (deliveryReportUid: string) =>
  `/delivery-report/tenants/${deliveryReportUid}/work_type_settings` as const
